export default "__VITE_ASSET__BL15ZSxo__"